module.exports = __webpack_public_path__ + "media/assets/images/clock-dab422934c0dc17c2b804a77724fed59.png";